import React, { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import MainBanner from "components/hero/AurumHeroContent.js";
import BlogMainContent from "components/hero/BlogMainContent.js";
import Stats from "components/features/ThreeColCenteredStatsPrimaryBackground.js";
import OurExpertise from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
import Features from "components/features/ThreeColWithSideImage.js";
import FeatureWithSteps from "components/features/TwoColWithSteps.js";
import Testimonials from "components/testimonials/TwoColumnWithImageAndRating.js";
import TrackRecord from "components/features/TwoColSingleFeatureWithStats2.js";
import Faqs from "components/faqs/SimpleWithSideImage.js";
import StrongBrandImage from "images/aurum_Icons/uiuxImage.svg";
import macHeroScreenshotImageSrc from "images/hero-screenshot-2.png";
import { Subheading as SubheadingBase } from "components/misc/Headings.js";
import { ReactComponent as Checkicon } from "../images/check.svg";
import BlogSummary from "components/cards/BlogSummary.js";
import BlogAss from "components/cards/blog_assessment.js";
import PreFooter from "components/footers/PreFooterBrand.js";
import CaseStudy from "components/testimonials/CaseStudyTextOnly.js";
import caseStudyLogoImage from "images/clientLogos/languagePantheon.png";
import caseStudyProfileImage from "images/lp_anuj_k_acharya.png";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
  useParams,
  useHistory,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import { serverUtilities } from "../services/serverutilities.service";
import axios from "axios";
import BlogTable from "./blogTable";

/* 🔹 Related section styles (copied logic, no behavior change) */
const RightColumn = tw.div`relative p-5 bg-[#f5f5f5] mt-12 lg:mt-0`;
const Sectionhead = styled.h2`
  ${tw`text-xl font-semibold text-gray-900 text-left mb-6`}
`;
const LinkBlock = styled.div`
  ${tw`flex flex-col space-y-4`}
`;
const Link = styled.a`
  ${tw`text-[#121a23] border-b-4 leading-loose`}
`;

const SubheadingSteps = tw.span`uppercase tracking-widest font-bold text-brand-500`;
const HighlightedText = tw.span`text-brand-500 `;
const BoldTag = styled.span`
  ${tw`text-textBlack font-bold`}
`;

let self_assessment = 0;

export default ({
  title = "Simplified On-Boarding",
  highlightedtext = "Get Started.",
  heading = "Easy to",
  CheckIcon = Checkicon,
}) => {
  const urlI = window.location.href;
  const history = useHistory();

  let urlF = urlI.split("?");
  const url = urlF[0].replace("--ym", "");
  let spliturl = url.split("/").pop();
  const splitPart = url.split("/")[3];

  let titleBlog = spliturl.replace(/-/g, " ");
  titleBlog = titleBlog.replace(/\b\w/g, (x) => x.toUpperCase());

  const [blogData, setBlogData] = useState("0");
  const [relatedblogData, setrelatedBlogData] = useState("0");
  const [blogProds, setBlogProds] = useState("0");
  const [blogBanners, setBlogBanners] = useState("0");
  const [coverImage, setCoverImage] = useState("");

  if (url.indexOf("self-assessment") > 0) self_assessment = 1;

  let URI = "https://youngminds.pro/tt/" + spliturl;

  useEffect(() => {
    if (blogData === "0") {
      const res = axios.get(URI);
      res.then((data) => {
        console.log(data);
        if (data.data.status === "0") {
          history.push("/404");
          return;
        }
        setBlogData(data.data.vals);
        setCoverImage(data.data);
        setrelatedBlogData(data.data.related);
      });
    }
  }, []);

  return (
    blogData.length > 0 &&
    blogData !== "0" &&
    relatedblogData !== "0" && (
      <>
        <AnimationRevealPage>
          <BlogMainContent
            roundedHeaderButton={true}
            mainTitle={blogData[0].title}
            subTitle={blogData[0].descrip}
            blogBanners={blogBanners}
            imageSrc={coverImage?.vals?.[0]?.cvr_img}
            showClient={false}
            header={splitPart}
            alt_text={blogData[0]?.cvr_img_type}
          />

          {self_assessment === 1 ? (
            <BlogAss
              heading="CA Tax Classes"
              data={blogData[0].html}
              relatedData={relatedblogData}
              blogProds={blogProds}
              blogBanners={blogBanners}
              blog_id={blogData[0].id}
              allBlogData={blogData[0]}
            />
          ) : (
            <BlogSummary
              heading="CA Tax Classes"
              data={blogData[0].chunks}
              relatedData={relatedblogData}
              blogProds={blogProds}
              blogBanners={blogBanners}
              blog_id={blogData[0].id}
              coverImage={coverImage}
            />
          )}

          {/* 🔹 Related Topics Section (EXACT as requested) 
          <RightColumn>
            <Sectionhead>Related Topics</Sectionhead>
            <LinkBlock>
              {relatedblogData && (
                <>
                  {relatedblogData.map((val) => (
                    <Link
                      key={val.link}
                      href={val.link.toLowerCase()}
                      target="_blank"
                    >
                      {val.title}
                    </Link>
                  ))}
                </>
              )}
            </LinkBlock>
          </RightColumn>
          */}
          <PreFooter
            fromPage="BlogPage"
            formheading="Get in Touch With Our Academic Counsellors to Help You In Your Preparations."
            formsubheading="Book Our Free Discussion Session Today"
          />
          <Footer />
        </AnimationRevealPage>
      </>
    )
  );
};
